import { generateResourceReducer } from '../generators/resource.reducer';

import * as types from './meeting-shortcuts.types';
import * as constants from './meeting-shortcuts.constants';

export const meetingShortcutsReducer = generateResourceReducer<types.IMeetingFolder>({
  STORE: constants.STORE_MEETING_SHORTCUT,
  CLEAR: constants.CLEAR_MEETING_SHORTCUT,
});

export const meetingShortcutsSelectedReducer = generateResourceReducer<types.IMeetingFolder>({
  STORE: constants.STORE_MEETING_SHORTCUTS_FOLDER,
  CLEAR: constants.CLEAR_MEETING_SHORTCUTS_FOLDER,
});
